module.exports = "<p>\n  ticket works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/tickets/single/ticket.component.html
// module id = ./src/app/tickets/single/ticket.component.html
// module chunks = main